// eslint-disable-next-line camelcase
import {legacy_createStore, applyMiddleware, combineReducers, compose} from 'redux';
import thunk from 'redux-thunk';
// import logger from 'redux-logger';
import {createLogger} from 'redux-logger';
import {createBrowserHistory} from 'history';
// import {connectRouter} from 'connected-react-router';
import auth from './auth'; // import all reducers from ducks/index.js
import common from './common';
import style from './style';
import work from './work';
import attachorder from './attachorder';
import contractDnt from './contractDnt';
import senroCode from './senroCode';
import grid from './grid';
import {reducer as formReducer} from 'redux-form';
import Conf from '../config/config.js';

import {persistReducer, persistStore} from 'redux-persist';
import storage from 'redux-persist/lib/storage';

// import {setStockUrl} from './common/actions';

export const history = createBrowserHistory();

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const appReducer = combineReducers({
  attachorder,
  auth,
  common,
  contractDnt,
  style,
  work,
  senroCode,
  grid,
  // router: connectRouter(history),
  form: formReducer,
});

const rootReducer = (state, action) => {
  if (action.type === 'DO_LOGOUT') {
    // state = undefined;
    const ret = {};
    // router情報については初期化せず継承する
    // ret.router = state.router;
    return appReducer(ret, action);
  }
  return appReducer(state, action);
};

// 永続化の設定
const persistConfig = {
  key: 'root', // Storageに保存されるキー名を指定する
  storage, // 保存先としてlocalStorageがここで設定される
  blacklist: ['router'], // `visibilityFilter`は保存しない
};

// 永続化設定されたReducerとして定義
const persistedReducer = persistReducer(persistConfig, rootReducer);

const logger = createLogger({
  diff: true,
  collapsed: true,
});

const middlewares = [];
middlewares.push(thunk);
// middlewares.push(routerMiddleware(history));

if (Conf.logger) {
  middlewares.push(logger);
}

const store = legacy_createStore(
    persistedReducer,
    window.REDUX_INITIAL_DATA,
    // window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__(),
    composeEnhancers(applyMiddleware(...middlewares)),
);
export const persistor = persistStore(store);
export default function configureStore(initialState = {}) {
  return store;
}
